import { ProjectExpense, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editProjectExpense(httpClient: HttpClient) {
  return (projectExpense: ProjectExpense, nextProjectExpense: ProjectExpense) =>
    new Promise<Identifiable<ProjectExpense>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<ProjectExpense>>({
          endpoint: `/expenses/${projectExpense.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            actualDate: nextProjectExpense.actualDate,
            expenseType: `expenseTypes/${nextProjectExpense.expenseType.uuid}`,
            name: nextProjectExpense.name,
            orderNumber: nextProjectExpense.orderNumber,
            plannedDate: nextProjectExpense.plannedDate,
            quantity: nextProjectExpense.quantity,
            unitAmount: nextProjectExpense.unitAmount,
          },
        })
        .then((updatedProjectExpense) => resolve(updatedProjectExpense))
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { editProjectExpense };
